import { useFetch } from "@/lib/axios.config";
import { NotificationListResponse, NotificationParams } from "./types";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { getNextPageParam } from "@/shared/utils/query";

const NOTIFICATION_LIMIT = 20;

const getNotifications = async (
  params: NotificationParams = {}
): Promise<NotificationListResponse> => {
  const { data } = await useFetch.get("/common/NotificationList", {
    params: {
      limit: params.limit ?? NOTIFICATION_LIMIT,
      offset: params.pageParam,
      is_read: params.is_read,
    },
  });
  return data;
};

const markNotificationAsRead = async (
  notificationId: string
): Promise<void> => {
  await useFetch.post(`/common/NotificationRead/${notificationId}`);
};

export const useInfiniteNotifications = (
  params: NotificationParams = { limit: 10 }
) => {
  return useInfiniteQuery({
    queryKey: ["notifications", params],
    queryFn: ({ pageParam = 0 }) => getNotifications({ pageParam, ...params }),
    initialPageParam: "0",
    getNextPageParam: getNextPageParam,
  });
};

export const useMarkNotificationAsReadMutation = () => {
  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      // queryClient.invalidateQueries({
      //   queryKey: ["notifications"],
      // });
    },
  });
};
